import React from "react";
import { useDispatch, useSelector } from "react-redux";

import LockFilledIcon from "@/Components/Icons/LockFilledIcon";
import { toggleOurServiceModal } from "@/reducers/clientcommon";

const NotAllowedButtonWrapper = ({
  children,
  rootClass = "",
  iconClass = "",
  _element = "div",
}) => {
  const { isPremiumAccount } = useSelector((state) => state.session);
  const dispatch = useDispatch();
  if (isPremiumAccount) {
    return children;
  }
  return React.createElement(
    _element,
    {
      className: `NotAllowedButtonWrapper_Wrapper cursor-pointer group/na relative overflow-hidden ${rootClass}`,
      onClick: () => {
        dispatch(toggleOurServiceModal(true));
        // showManagedServiceToast()
      },
    },
    children,
    React.createElement(
      "div",
      {
        className:
          "bg-notAllowedOverlay absolute left-0 top-0 flex h-full w-full items-center justify-center opacity-0 transition-opacity group-hover/na:opacity-100",
      },
      React.createElement(LockFilledIcon, { cls: iconClass }),
    ),
  );
};

export default NotAllowedButtonWrapper;
